<template>
    <div>
        <b-modal
            id="add-system-user-popup"
            ref="modal"
            :title="title"
            size="sm"
            hide-footer
            modal-class="hide-footer"
            no-close-on-backdrop
            no-close-on-esc
            :hide-header-close="loading"
            @hidden="onHidden"
        >
            <b-form
                @submit.stop.prevent="onSubmit()"
                @reset.stop.prevent="onHidden"
            >
                <div class="row custom-model-form">
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-1"
                            label="Phone Number"
                            label-for="user-name"
                        >
                            <b-form-input
                                id="user-name"
                                v-model="formData.phoneNumber"
                                v-validate="{
                                    required: true,
                                    max: 20,
                                    min: 6,
                                    // regex: /^\S*$/,
                                }"
                                name="phoneNumber"
                                type="number"
                                :class="{
                                    'is-invalid': errors.has('phoneNumber'),
                                }"
                                autocomplete="no"
                                placeholder="Enter phone number"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-12 row-min-space">
                        <div class="row">
                            <div class="col-md-6">
                                <b-form-group
                                    id="input-group-2"
                                    label="First Name"
                                    label-for="first-name"
                                >
                                    <b-form-input
                                        id="first-name"
                                        v-model="formData.firstName"
                                        v-validate="{
                                            required: true,
                                            max: 50,
                                        }"
                                        name="first name"
                                        type="text"
                                        :class="{
                                            'is-invalid':
                                                errors.has('first name'),
                                        }"
                                        autocomplete="no"
                                        placeholder="Enter first name"
                                    ></b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-6">
                                <b-form-group
                                    id="input-group-3"
                                    label="Last Name"
                                    label-for="last-name"
                                >
                                    <b-form-input
                                        id="last-name"
                                        v-model="formData.lastName"
                                        v-validate="{
                                            required: true,
                                            max: 50,
                                        }"
                                        name="last name"
                                        :class="{
                                            'is-invalid':
                                                errors.has('last name'),
                                        }"
                                        autocomplete="no"
                                        placeholder="Enter last name"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-4"
                            label="Email Address"
                            label-for="email-address"
                        >
                            <b-form-input
                                id="email-address"
                                v-model="formData.email"
                                v-validate="{
                                    required: true,
                                    email: true,
                                }"
                                name="email"
                                :class="{
                                    'is-invalid': errors.has('email'),
                                }"
                                autocomplete="no"
                                placeholder="Enter email address"
                            ></b-form-input>
                        </b-form-group>
                    </div>

                    <div v-if="user.accountType != 'lite'" class="col-md-12">
                        <b-form-group
                            id="input-group-5"
                            label="Role"
                            label-for="role"
                        >
                            <b-form-select
                                v-model="formData.roleId"
                                v-validate="{ required: true }"
                                name="role"
                                :options="roleOptions"
                            ></b-form-select>
                        </b-form-group>
                    </div>
                    <div v-if="!selectedItem" class="col-md-12">
                        <div class="system-user-warning">
                            <i class="icon-error_outline"></i>
                        </div>
                        <div class="system-user-details">
                            <p>
                                We will send email to user to create password
                                and activate account.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        :btn-label="buttonLabel"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <base-button
                        btn-label="Cancel"
                        btn-type="reset"
                        :disabled="loading"
                        btn-variant="link"
                    ></base-button>
                </div>
                <base-toast></base-toast>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import _ from 'lodash'
import resource from '@/api/resource'

// const roleApi = new resource('access-control/roles')
const rolesMinApi = new resource('access-control/roles-minified')
const dataSegmentApi = new resource('access-control/data-segments')

export default {
    components: {
        Multiselect,
    },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        parentName: { type: String },
    }, // End of Component > props
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */

    data() {
        return {
            formData: this.initializeFormData(),
            roleOptions: [],
        }
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'selectedItem', 'hidePopup', 'user']),
        title() {
            return this.selectedItem ? 'Modify Team Member' : 'Add Team Member'
        }, // End of title() method

        buttonLabel() {
            return this.selectedItem ? 'Update' : 'Create'
        },
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        /**
         * Handle when the selected has been updated
         *
         * @return {void}
         */
        selectedItem(value) {
            let self = this
            if (value !== null && value !== undefined) {
                Object.assign(this.formData, value)
                this.formData.id = value._id
            } else if (this.$refs.modal._isShown) {
                this.$refs.modal.hide()
            } else {
                this.onHidden()
            }
        },
        /**
         * Handle when the popup hide
         *
         * @return {void}
         */
        hidePopup(value) {
            if (value) {
                this.onHidden()
            }
        },
    }, // End of Component > watch

    mounted() {
        // get datasegment and roles options list
        this.getRolesList()
    },
    methods: {
        initializeFormData() {
            return {
                id: '',
                firstName: '',
                lastName: '',
                email: '',
                roleId: '',
            }
        },
        async getRolesList() {
            // const result = await rolesMinApi.list( {except: ['Super Admin', 'User']} );
            const result = await rolesMinApi.list()
            if (result && result.data) {
                let tempRoles = result.data.data.map((el) => ({
                    value: el.id,
                    text: el.title,
                }))
                tempRoles = [
                    { value: '', text: 'Please select role' },
                    ...tempRoles,
                ]
                this.roleOptions = tempRoles
            }

            if (this.user.accountType == 'lite') {
                let adminRole = this.roleOptions.find(
                    (option) => option.text === 'Admin'
                )
                this.formData.roleId = adminRole.value
            }
        },
        async onSubmit() {
            const result = await this.$validator.validateAll()
            if (result) {
                try {
                    const id = this.formData.id 
                    const encryptedData = this.$encryptData({...this.formData});
                    const payload = {data: encryptedData, id: id }
                    if (this.formData.id) {
                        //update system user
                        if (this.parentName == 'team-members') {
                            await this.$store.dispatch(
                                'updateTeamMember',
                                payload
                            )
                        } else {
                            await this.$store.dispatch(
                                'updateSystemUser',
                                payload
                            )
                        }
                    } else {
                        if (this.parentName == 'team-members') {
                            await this.$store.dispatch(
                                'addTeamMember',
                                payload
                            )
                        } else {
                            let adminRole = this.roleOptions.find(
                                (option) =>
                                    option.value === this.formData.roleId
                            )

                            let dataSegmentData = {
                                id: '',
                                profilePicture: {
                                    fileName: '',
                                    originalName: '',
                                },
                                username: this.formData.username,
                                firstName: this.formData.firstName,
                                lastName: this.formData.lastName,
                                email: this.formData.email,
                                companyName: '',
                                phoneNumber: this.formData.phoneNumber,
                                roleTitle: adminRole.text,
                                dataSegmentIds: [],
                                companyType: 'financial',
                                accountType: 'standard',
                                nationality: process.env.VUE_APP_COUNTRY,
                                nationalityTemp:
                                    process.env.VUE_APP_COUNTRY_TEMP,
                            }
                            let dataSegment = await this.$store.dispatch(
                                'addDataSegment',
                                dataSegmentData
                            )

                            if (dataSegment.data._id) {
                                this.formData.dataSegmentIds = [
                                    dataSegment.data._id,
                                ]
                                this.formData.roleTitle = adminRole.text
                                await this.$store.dispatch(
                                    'customerSignUp',
                                    this.formData
                                )
                            } else {
                                console.log('DataSegment ID not found')
                            }
                        }
                    }
                } catch (error) {
                    console.log(error, 'There is an error on submit')
                }
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        },
        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            // clear the selected item
            this.$store.commit('clearItem')
            Object.assign(this.formData, this.initializeFormData())
            this.$validator.reset()
            this.$refs.modal.hide()
        }, // End of onHidden() method
    },
}
</script>
